"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _numberFormatter = require("../../helpers/numberFormatter");
var _dateHelper = require("../../helpers/dateHelper");
var _orderHistoryActions = require("../../redux/actions/orderHistoryActions");
var _OrdersListComponent = _interopRequireDefault(require("./OrdersListComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* 
  filterBySelectedProduct (bool) => filtering orders by productId
  dateFrom (number) => start for filtering
  dateTo (number) => end for filtering
  ordersCount(number) => number of orders to show on 1 page
  pageNumber(number) => number of page to show orders, should be used with defined ordersCount
*/

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _state$apexCore$order = state.apexCore.orderHistory,
    inactiveOrders = _state$apexCore$order.inactiveOrders,
    accountTrades = _state$apexCore$order.accountTrades;
  var _state$apexCore = state.apexCore,
    decimalPlaces = _state$apexCore.product.decimalPlaces,
    instruments = _state$apexCore.instrument.instruments,
    position = _state$apexCore.position;
  var filteredOrders = inactiveOrders;
  var selectedProductId = position.selectedProductId;
  if (ownProps.filterBySelectedProduct && selectedProductId && instruments.length !== 0) {
    var instrumentsToShow = instruments.filter(function (i) {
      return i.Product1 === selectedProductId || i.Product2 === selectedProductId;
    }).map(function (i) {
      return i.InstrumentId;
    });
    filteredOrders = inactiveOrders.filter(function (order) {
      return instrumentsToShow.indexOf(order.Instrument) !== -1;
    });
  }
  if (ownProps.dateFrom) {
    filteredOrders = filteredOrders.filter(function (order) {
      return order.ReceiveTime >= ownProps.dateFrom;
    });
  }
  if (ownProps.dateTo) {
    filteredOrders = filteredOrders.filter(function (order) {
      return order.ReceiveTime <= ownProps.dateTo;
    });
  }
  if (ownProps.ordersCount) {
    filteredOrders = filteredOrders.slice(0, ownProps.ordersCount);
  }
  var formatedOrders = filteredOrders.map(function (order, index) {
    var _ref = instruments.find(function (i) {
        return i.InstrumentId === order.Instrument;
      }) || {},
      Product1Symbol = _ref.Product1Symbol;
    var _ref2 = instruments.find(function (i) {
        return i.InstrumentId === order.Instrument;
      }) || {},
      Product2Symbol = _ref2.Product2Symbol;
    return {
      quantity: "".concat((0, _numberFormatter.formatNumberToLocale)(order.QuantityExecuted, decimalPlaces[Product1Symbol]), " ").concat(Product1Symbol),
      price: "".concat((0, _numberFormatter.formatNumberToLocale)(order.Price, decimalPlaces[Product2Symbol]), " ").concat(Product2Symbol),
      orderId: order.OrderId,
      orderType: order.OrderState,
      avgPrice: "".concat((0, _numberFormatter.formatNumberToLocale)(order.AvgPrice, decimalPlaces[Product2Symbol]), " ").concat(Product2Symbol),
      notional: "".concat((0, _numberFormatter.formatNumberToLocale)(order.GrossValueExecuted, decimalPlaces[Product2Symbol]), " ").concat(Product2Symbol),
      dateTime: (0, _dateHelper.formatDateTime)(order.ReceiveTime),
      side: order.Side,
      instrument: (instruments.find(function (i) {
        return i.InstrumentId === order.Instrument;
      }) || {}).Symbol,
      product1Symbol: Product1Symbol,
      product2Symbol: Product2Symbol,
      itemId: index
    };
  });
  return {
    orders: formatedOrders,
    decimalPlaces: decimalPlaces,
    accountTrades: accountTrades
  };
};
var mapDispatchToProps = {
  FetchAccountTradesForOrderId: _orderHistoryActions.FetchAccountTradesForOrderId
};
var container = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_OrdersListComponent["default"]);
var _default = exports["default"] = container;